import { collection, query, where, getCountFromServer, orderBy, limit, startAfter, getDocs } from "firebase/firestore";
import {mapState} from "vuex"
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export default {
    data() {
        return {
            col: null,
            filterOption: '',
            filterOptions: [
                {value: '', name: '전체', dataKey: ''},
            ],
            pageData: {
                size: 50,
                lastSort: null,
                total: 0,
                page: 1,
            },
            sortData: {
                type: '',
                order: 'desc',
            },
            sizeList: [50, 100],
            finishGetList: false,
            loadingMore: false,
            removeLoading: true,
            List: [],
            beforeScrollTop: 0,
            scrollDocument: '.has_infinite_loading'
        }
    },
    computed: {
        ...mapState({
            db: state => state.db,
        })
    },
    methods: {
        getOptionData() {
            let optionData = this.filterOptions.filter(sio => sio.value === this.filterOption);
            if(optionData.length === 0) {
                return this.filterOptions[0];
            }
            return optionData[0]
        },
        _getOptionDataValue(optionData) {
            let dataValue = '';
            if(util.isEmpty(optionData)) {
                return dataValue;
            }
            if(optionData.hasOwnProperty('dataValueName') && this.hasOwnProperty(optionData.dataValueName)) {
                dataValue = this[optionData.dataValueName];
            }else if(!util.isEmpty(optionData.dataValue)) {
                dataValue = optionData.dataValue;
            }
            return dataValue;
        },
        _getOptionDataKey(optionData) {
            let dataKey = '';
            if(util.isEmpty(optionData)) {
                return dataKey;
            }
            if(!util.isEmpty(optionData.dataKey)) {
                dataKey = optionData.dataKey;
            }
            return dataKey
        },
        _getOptionFilterType(optionData) {
            let filterType = '==';
            if(util.isEmpty(optionData)) {
                return filterType;
            }
            if(!util.isEmpty(optionData.filterType)) {
                filterType = optionData.filterType;
            }
            return filterType;
        },
        setQuery(q) {
            let optionData = this.getOptionData();
            if(!optionData) {
                return q;
            }
            let dataValue = this._getOptionDataValue(optionData);
            let filterType = this._getOptionFilterType(optionData);
            let dataKey = this._getOptionDataKey(optionData);
            if(dataKey === '') {
                return q;
            }
            if(filterType === 'range') {
                if(!util.isEmpty(dataValue[0])) {
                    if(!isNaN(dataValue[0])) {
                        dataValue[0] = Number(dataValue[0])
                    }
                    q = q.where(dataKey, ">=", dataValue[0]);
                }
                if(!util.isEmpty(dataValue[1])) {
                    if(!isNaN(dataValue[1])) {
                        dataValue[1] = Number(dataValue[1])
                    }
                    q = q.where(dataKey, "<=", dataValue[1]);
                }
            }else if (filterType == 'in'){
                q = q.where(dataKey, filterType, [dataValue]);
            }
            else{
                q = q.where(dataKey, filterType, dataValue);
            }
            return q;
        },
        isSetOrderBy() {
            return !util.isEmpty(this.sortData.type) && !util.isEmpty(this.sortData.order);
        },
        setOrderBy(q) {
            if(this.isSetOrderBy()) {
                q =  q.orderBy(this.sortData.type, this.sortData.order);
            }
            return q;
        },
        runSearch() {
            if(!this.col) return;
            this.pageData.page = 1;
            this.List = [];
            this.pageData.lastSort = null;
            let optionData = this.getOptionData();
            if(optionData.setOrder) {
                this.sortData.type = optionData.dataKey;
            }else {
                // this.sortData.type = '';
            }
            this.setFilterQuery(optionData)
            this.getList(true);
        },
        async getList(isFirst=false) {
            this.setBeforeScrollTop();
            this.finishGetList = false;
            EventBus.$emit('apiLoading', true);
            let q = this.col;
            q = this.setQuery(q);
            q = this.setOrderBy(q);
            if(isFirst) {
                this.pageData.total = await this._getCount(q);
            }
            if(!util.isEmpty(this.pageData.lastSort)) {
                q = q.startAfter(this.pageData.lastSort);
            }
            q = q.limit(this.pageData.size);
            let list = await this._getData(q);
            this.List = this.List.concat(list);
            setTimeout(() => {
                this.moveScroll();
                this.finishGetList = true;
                EventBus.$emit('apiLoading', false);

                if(list.length === 0) {
                    this.removeLoading = true;
                }else {
                    this.removeLoading = false;
                }
            }, 500)
        },
        _getCount(q) {
            return this.col.get().then(countSnap => {
                let count = countSnap.docs.length;
                return count;
            })
        },
        _getData(q) {
            let list = [];
            return new Promise(resolve => {
                q.get().then(storeDocs => {
                    if(storeDocs.docs.length === 0) {
                        resolve(list);
                        return;
                    }
                    util.Array.each(storeDocs.docs, (storeDoc, index, arr) => {
                        let storeData = storeDoc.data();
                        list.push(storeData)
                        if(storeDocs.docs.length === list.length ) {
                            this.pageData.lastSort = storeDoc;
                            resolve(list);
                        }
                    })
                })
            })
        },
        setFilterQuery(optionData) {
            let dataKey = this._getOptionDataValue(optionData);
            let value = optionData.value;
            let dataValue = this._getOptionDataValue(optionData);
            let replacePath = `${this.$route.path}?size=${this.pageData.size}&`;
            if(!util.isEmpty(dataValue) && !util.isEmpty(value) && !util.isEmpty(dataKey)) {
                let setValue = JSON.stringify(dataValue);
                replacePath += `ty=${value}&vl=${setValue}&`
            }
            if(this.isSetOrderBy()) {
                replacePath += `sort=${this.sortData.type}&order=${this.sortData.order}&`
            }
            let last = replacePath[replacePath.length - 1];
            if(last === '?' || last === '&') {
                replacePath = replacePath.slice(0, -1);
            }
            if(decodeURIComponent(this.$route.fullPath) != (replacePath)) {
                this.$router.replace(replacePath)
            }
        },
        setQueryToFilter() {
            let query = this.$route.query;
            if(query.hasOwnProperty('ty') && query.hasOwnProperty('vl')) {
                this.filterOption = query.ty;
                let optionData = this.getOptionData();
                let value = JSON.parse(query.vl);
                if(optionData.hasOwnProperty('dataValueName') && this.hasOwnProperty(optionData.dataValueName)) {
                    this[optionData.dataValueName] = value;
                }
            }
            if(query.hasOwnProperty('sort') && query.hasOwnProperty('order')) {
                this.sortData.type = query.sort;
                this.sortData.order = query.order;
            }
            if(query.hasOwnProperty('size') && !isNaN(query.size)) {
                this.pageData.size = Number(query.size);
            }
        },
        loadMore($event) {
            if (this.loadingMore) {
                return;
            }
            this.loadingMore = true;
            this.pageData.page += 1;
            this.getList();
            this.lazyLoadComplete($event);
        },
        lazyLoadComplete($event) {
            if (!this.finishGetList) {
                setTimeout(() => {
                    this.lazyLoadComplete($event);
                }, 500)
                return false;
            }
            $event.loaded();
            this.loadingMore = false;
        },
        setBeforeScrollTop() {
            let doc = document.querySelector(this.scrollDocument);
            if(util.isEmpty(doc)) {
                return;
            }
            this.beforeScrollTop = doc.scrollTop;
        },
        moveScroll() {
            let doc = document.querySelector(this.scrollDocument);
            if(util.isEmpty(doc)) {
                return;
            }
            doc.scrollTop = this.beforeScrollTop;
        },
    },
}
